<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :filter-columns="filterColumns"
    :actionButtons="[]"
    :title="$t('menu.dataAnalysis')"
    :onFetchData="onFetchData"
    ref="sourcePage"
    resource="product_design_analyses"
  >
    <template v-slot:action>
      <el-button type="primary" @click="() => exportClick(selection)">导出</el-button>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ProductDesignAnalyses extends Vue {
  @Prop(String) type;

  analysisMetric = this.$route.query.analysis_metric || 'design_type';

  async onFetchData() {
    const data = await this.$request.get('product_design_analyses', { params: { ...this.$route.query } });
    return {
      data
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      {
        prop: 'publication_on_gteq',
        label: `${this.$t('productDesign.publicationOn')}大于等于`,
        renderCell: {
          component: 'datePicker'
        }
      },
      {
        prop: 'publication_on_lteq',
        label: `${this.$t('productDesign.publicationOn')}小于等于`,
        renderCell: {
          component: 'datePicker'
        }
      },
      {
        prop: 'analysis_metric',
        label: '维度',
        renderCell: {
          component: 'select',
          props: {
            options: [
              { label: this.$t('productDesign.designType'), value: 'design_type', default: true },
              { label: this.$t('productDesign.patternFactory'), value: 'pattern_factory' },
              { label: this.$t('productDesign.designer'), value: 'designer_id' }
            ],
            value: this.analysisMetric,
          },
          on: {
            change: (value) => {
              if (this.analysisMetric !== value) {
               this.analysisMetric = value;
              }
            }
          }
        }
      }
    ].filter(Boolean)

    return array;
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns() {
    const array = [
      {
        prop: 'project',
        label: '统计项',
      },
      {
        prop: 'overdue_count',
        label: '逾期数量',
      },
      {
        prop: 'overdue_percent',
        label: '逾期比例',
      },
      {
        prop: 'on_time_count',
        label: '准时数量',
      },
      {
        prop: 'on_time_percent',
        label: '准时比例',
      },
      {
        prop: 'in_advance_count',
        label: '提前数量',
      },
      {
        prop: 'in_advance_percent',
        label: '提前比例',
      },
    ].filter(Boolean)

    return array;
  }


  async exportClick() {
    await this.$request.get('/product_design_analyses/export', { ...this.$route.query });
    this.$message.success('文件正在导出，导出成功后将会发送到邮箱');
  }
}

export const route = [
  {
    path: '/product_design_analyses',
    name: 'product_design_analyses.index',
    component: ProductDesignAnalyses,
    props: {
      type: 'index',
    }
  },
]
</script>
